<label
  mat-dialog-title
  class="uk-text-title"
  *ngIf="isAuthorization; else title"
  >Editar flete
</label>
<ng-template #title>
  <label mat-dialog-title class="uk-text-title">Solicitar autorización </label>
</ng-template>
<mat-dialog-content>
  <form action="" [formGroup]="myForm">
    <div class="e-s-container-center">
      <div class="e-s-container-center e-s-action">
        <label class="uk-text-body-strong">¿Que acción desea realizar?</label>
        <mat-radio-group formControlName="action" id="action">
          <mat-radio-button
            class="radio-button"
            *ngFor="let service of actions"
            [id]="'editShippi-' + service.value"
            [value]="service.id"
          >
            {{ service.value }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="e-s-container-center">
        <div
          *ngIf="myForm.controls['action'].value === 'updateShipping'; else delete"
          class="e-s-container-center"
        >
          <mat-form-field class="input-text-shipping">
            <mat-label>{{'* Modificar el flete ' + this.currency + '/.' +  metadata.previous + ' a'}}</mat-label>
            <input
              matInput
              formControlName="shipping"
              type="number"
              min="1"
              max="300"
              id="shipping"
              class="input-shipping"
              (keypress)="round($event)"
              autocomplete="off"
            />
            <span matSuffix>.00</span>
          </mat-form-field>
          <div>
            <mat-hint class="uk-text-label"
              >* Este valor reemplazará al flete actual</mat-hint
            >
            <mat-hint class="uk-text-label"
              >* El costo mínimo es {{ this.currency }}/1.00</mat-hint
            >
          </div>
        </div>
        <ng-template #delete>
          <mat-icon class="icon-warn">delete</mat-icon>
          <label class="uk-text-body-strong e-s-title"
            >¿Está seguro que desea eliminar?</label
          >
        </ng-template>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="card-button" align="center">
  <button
    mat-stroked-button
    class="border-box b-s"
    (click)="onNoClick()"
    id="cancelDispatchTypes"
  >
    Cancelar
  </button>
  <button
    mat-flat-button
    id="cancelEditShipping"
    (click)="submit()"
    cdkFocusInitial
    class="button-primary-event button-success"
  >
    {{
      stateAction === "AM"
        ? "Modificar flete"
        : stateAction === "AE"
        ? "Eliminar flete"
        : "Validar"
    }}
  </button>
</mat-dialog-actions>
<button
  id="closeEditShipping"
  mat-button
  (click)="onNoClick()"
  class="dialog-close"
>
  <mat-icon class="close">close</mat-icon>
</button>
